import React, { useState, useEffect } from 'react';
import { Typography, Stack } from '@mui/material';
import TicketPrice from './TicketPrice';
import TicketDesc from './TicketDesc';
import { usePromotions } from '@/store';

function TicketInfo({ ticket, showPrice = false }) {
  const { name, ticket_type_id } = ticket;
  const [promotion, setPromotion] = useState();
  const { promotions } = usePromotions();
  useEffect(() => {
    if (promotions) {
      if (
        promotions.valid_for_ticket_type === 'all' ||
        promotions.valid_for_ticket_type === ticket_type_id.toString() ||
        promotions?.valid_for_ticket_type_list?.includes(ticket_type_id)
      ) {
        if (promotions.discount_type === 'bundle') {
          setPromotion(promotions.bundle_rule);
        }
      }
    } else {
      setPromotion(null);
    }
  }, [promotions]);
  return (
    <Stack direction="column">
      <Typography variant="subtitle1" component="div">
        {name}{' '}
        {promotion && (
          <Typography
            component="span"
            variant="body1"
            sx={{
              color: '#139e65',
              fontWeight: 600,
            }}
          >
            {promotion}
          </Typography>
        )}
      </Typography>
      <>
        {showPrice && <TicketPrice ticket={ticket} showDiscount />}
        {!showPrice && <TicketDesc ticket={ticket} />}
      </>
    </Stack>
  );
}

export default TicketInfo;
